/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Serializer for appointment duration dropdown options.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface DurationOption { 
    value: number;
    label: string;
}
export const DurationOption_value_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const DurationOption_label_Validators: ValidatorFn[] =
    [  Validators.required, ];


